"use client";

import { Check, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/locales/client";

const FEATURE_KEYS = [
  "cancellation.comparison.features.fileUploads",
  "cancellation.comparison.features.youtubeUploads",
  "cancellation.comparison.features.tutorMessages",
  "cancellation.comparison.features.autocompletions",
  "cancellation.comparison.features.noteTakerSessions",
] as const;

interface ComparisonStepProps {
  onKeep: () => void;
  onCancel: () => void;
}

export const ComparisonStep = ({ onKeep, onCancel }: ComparisonStepProps) => {
  const t = useI18n();

  return (
    <div className="flex flex-col gap-6">
      <div>
        <div className="flex items-center mb-3">
          <p className="flex-1 text-sm font-medium text-muted-foreground">
            {t("cancellation.comparison.whatYouGet")}
          </p>
          <p className="w-16 text-center text-sm font-medium text-muted-foreground">
            {t("cancellation.comparison.free")}
          </p>
          <p className="w-16 text-center text-sm font-medium text-brand-primary">
            {t("cancellation.comparison.premium")}
          </p>
        </div>
        <div className="flex flex-col gap-3">
          {FEATURE_KEYS.map((key) => (
            <div key={key} className="flex items-center">
              <p className="flex-1 text-sm text-foreground">{t(key)}</p>
              <div className="w-16 flex justify-center">
                <X className="size-4 text-muted-foreground" />
              </div>
              <div className="w-16 flex justify-center">
                <Check className="size-4 text-brand-primary" />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <Button onClick={onKeep} className="w-full">
          {t("cancellation.comparison.keepPremium")}
        </Button>
        <Button
          onClick={onCancel}
          className="w-full border border-red-200 bg-white text-destructive shadow-sm hover:bg-slate-100"
        >
          {t("cancellation.comparison.cancelPremium")}
        </Button>
      </div>
    </div>
  );
};
